import React from 'react';
import {t} from '@lingui/core/macro';

import LoaderCentered from 'shared/ui/LoaderCentered/LoaderCentered';
import HttpIncidents from 'features/http/ui/HttpIncident/HttpIncidents/HttpIncidents';
import TableBox from 'shared/ui/Box/TableBox/TableBox';
import PlugNoIncidents from 'shared/ui/Plugs/PlugNoIncidents/PlugNoIncidents';
import {IHttpMonitorItem} from 'features/http/model/HttpMonitor/IHttpMonitor';
import useHttpMonitorIncidents from 'features/http/model/useHttpMonitorIncidents';

import HttpMonitorSectionTitle from './HttpMonitorSectionTitle/HttpMonitorSectionTitle';

interface IHttpMonitorIncidentsProps {
    monitor: IHttpMonitorItem,
}

const HttpMonitorIncidents: React.FC<IHttpMonitorIncidentsProps> = ({
    monitor,
}) => {
    const {pagination, isLoading, isFetching, sort, setSort, setPage} = useHttpMonitorIncidents(monitor.uuid);

    return <TableBox>
        <LoaderCentered active={isFetching}/>
        <HttpMonitorSectionTitle title={t`Инциденты`} name={monitor.name}/>

        {
            pagination
            && <HttpIncidents
                pagination={pagination}
                hideMonitor={true}
                isLoading={isLoading}
                sort={sort}
                setSort={setSort}
                setPage={setPage}
                plug={pagination.items.length === 0 && <PlugNoIncidents/>}
            />
        }
    </TableBox>;
};

export default HttpMonitorIncidents;